import { CONFIG } from '../utils/config';

const PENDING_EMAIL_KEY = 'quikr_pending_email';

export const getPendingEmail = () => localStorage.getItem(PENDING_EMAIL_KEY) || '';

export const rememberPendingEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return;
  }
  localStorage.setItem(PENDING_EMAIL_KEY, email.trim().toLowerCase());
};

export const clearPendingEmail = () => {
  localStorage.removeItem(PENDING_EMAIL_KEY);
};

export async function requestEmailConfirmation(email) {
  const normalizedEmail = (email || '').trim().toLowerCase();
  const targetEmail = normalizedEmail || getPendingEmail();

  if (!targetEmail) {
    throw new Error('Veuillez renseigner une adresse email.');
  }

  rememberPendingEmail(targetEmail);

  const response = await fetch(`${CONFIG.BASE_URL}/request-email-confirmation`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mail: targetEmail }),
  });

  const isJson = (response.headers.get('content-type') || '').includes('application/json');
  const data = isJson ? await response.json() : {};

  if (!response.ok) {
    const error = new Error(
      data?.error || "Impossible d'envoyer un nouvel email de confirmation."
    );
    error.status = response.status;
    throw error;
  }

  return data;
}

export async function verifyEmailToken(verificationId) {
  const response = await fetch(`${CONFIG.BASE_URL}/verify-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ verification_id: verificationId }),
  });

  const isJson = (response.headers.get('content-type') || '').includes('application/json');
  const data = isJson ? await response.json() : {};

  if (!response.ok) {
    const error = new Error(data?.error || "Impossible de verifier cet email.");
    error.status = response.status;
    throw error;
  }

  return data;
}
